module.exports = __webpack_public_path__ + "img/edit.96a01f06.svg";